module.exports = __webpack_public_path__ + "img/RAFullLogo_tiny.bfdfdb2f.png";